import { render, staticRenderFns } from "./si_finishRiddle.vue?vue&type=template&id=1e7638c9&scoped=true&"
import script from "./si_finishRiddle.vue?vue&type=script&lang=js&"
export * from "./si_finishRiddle.vue?vue&type=script&lang=js&"
import style0 from "./si_finishRiddle.vue?vue&type=style&index=0&id=1e7638c9&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e7638c9",
  null
  
)

export default component.exports